// Add your JS customizations here

/**
 * Show loan offer details in a modal.
 */
function showDetails(event, offerId) {
  event.preventDefault();
  new instacash.Modal(document.getElementById("LoanDetails-"+offerId), []).show();
  var classname = document.getElementsByClassName("details-nav");

  var scrollToTheElement = function () {
    var element = document.getElementById(this.getAttribute("data-href"));
    var navLinks = this.parentNode.parentNode.querySelectorAll(".details-nav");
    for (var i = 0; i < navLinks.length; i++) {
      navLinks[i].classList.remove("active");
    }
    this.classList.add("active");
    element.parentNode.scrollTo({top: element.offsetTop, behavior: "smooth"});
  };

  for (var i = 0; i < classname.length; i++) {
    classname[i].addEventListener("click", scrollToTheElement, false);
  }
}

/**
 * Format number to a standard display.
 */
function numberFormat(nStr) {
  nStr += '';
  var x = nStr.split('.');
  var x1 = x[0];
  var x2 = x.length > 1 ? ',' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ' ' + '$2');
  }
  return x1 + x2;
};

/**
 * Display a lead form in global modal template.
 */
function icashGetFormTemplate(offerId = null, agent = null) {

    var modal = document.getElementById("callback-modal-content");
    modal.querySelector("textarea[name='message']").classList.add("d-none");
    modal.querySelector("textarea[name='message']").setAttribute("disabled", "disabled");
    modal.querySelector("input[name='form_type']").value = "Callback";
    modal.querySelector("input[name='redirect']").value = false;

    if ( null != offerId ) {
      if ( true == agent ) {
        modal.querySelector(".modal-title").innerText = document.getElementById("agent-modal-title").innerText;
        modal.querySelector(".modal-description").innerHTML = document.getElementById("agent-modal-description").innerHTML;
        modal.querySelector(".modal-side").innerHTML = document.getElementById("agent-modal-side").innerHTML;
        modal.querySelector("input[name='form_type']").value = "Agent Lead";
        modal.querySelector("input[name='agency']").value = document.getElementById("agent-company").innerText;
        modal.querySelector("input[name='referrer']").value = document.getElementById("agent-name").innerText;
        modal.querySelector("input[name='offer_id']").value = offerId;
        modal.querySelector("input[name='offer_id']").removeAttribute("data-offer-url");
        modal.querySelector("textarea[name='message']").classList.remove("d-none");
        modal.querySelector("textarea[name='message']").removeAttribute("disabled");

      } else {

        var offerCard = document.querySelector("#offer-" + offerId);

        modal.querySelector("input[name='offer_id']").value = offerId;
        modal.querySelector("input[name='form_type']").value = "OLM Redirect";
        modal.querySelector("input[name='redirect']").value = true;
        modal.querySelector("input[name='offer_id']").setAttribute("data-offer-url", offerCard.dataset.offerUrl);
        modal.querySelector(".modal-title").innerText = document.getElementById("offer-title").innerHTML;
        modal.querySelector(".modal-description").innerHTML = document.getElementById("offer-description").innerHTML;
        modal.querySelector(".modal-side").innerHTML = fillTemplate(offerId, offerCard).innerHTML;

      }
    } else {

      modal.querySelector(".modal-title").innerText = document.getElementById("callback-title").innerText;
      modal.querySelector(".modal-description").innerHTML = document.getElementById("callback-description").innerHTML;
      modal.querySelector(".modal-side").innerHTML = document.getElementById("callback-side").innerHTML;
      modal.querySelector("input[name='offer_id']").value = "";
      modal.querySelector("input[name='offer_id']").removeAttribute("data-offer-url");

      // Extend template
      if ( modal.dataset.extend ) {
        document.addEventListener("hidden.bs.modal", loopSteps(modal));
        loopSteps(modal);
      }
    }

    modal.querySelector("input[name='callback_submit']").disabled = false;
    modal.querySelector(".modal-body").style.display = 'block';
    modal.querySelector(".text-block").style.display = 'block';

    // var $siteKey = modal.querySelector(".callback-modal.callback-form").dataset.sitekey;
    //
    // if ("" !== $siteKey) {
    //   grecaptcha.execute($siteKey, {action:"validate_captcha"}).then(function(token) {
    //     document.querySelector(".callback-modal.callback-form input[name='g-recaptcha']").value = token;
    //   });
    // }

    new instacash.Modal(document.getElementById('CallbackModal'), []).show();
    modal.querySelector("form input[name='last_name']").focus();

}

/**
 * Fill loan offer template.
 */
function fillTemplate(offerId, offerCard) {
  var template = document.getElementById("offer-side");

  template.querySelector(".offer-image").src = offerCard.querySelector(".offer-image").src;
  template.querySelector(".offer-image").alt = offerCard.querySelector(".offer-partner").innerText;
  template.querySelector(".offer-partner").innerText = offerCard.querySelector(".offer-partner").innerText;
  template.querySelector(".offer-name").innerText = offerCard.querySelector(".offer-name").innerText;
  template.querySelector(".offer-monthly").innerText =  offerCard.querySelector(".offer-monthly").innerText;
  template.querySelector(".offer-total").innerText = offerCard.querySelector(".offer-total").innerText;
  template.querySelector(".offer-apr").innerText = offerCard.querySelector(".offer-apr").innerText;
  template.querySelector(".details").setAttribute("onclick", "globalThis.instacash.showDetails(event, " + offerId + ");");

  return template;
}
/**
 * Set range input design and functionality.
 */
function rangeInput() {
  const
  range = document.getElementById("loan-duration"),
  rangeV = document.getElementById("rangeV"),
  setValue = ()=>{
    const newValue = Number((range.value - range.min) * 100 / (range.max - range.min)),
    newPosition = 10 - (newValue * 0.2);

    rangeV.innerHTML = `<span>${range.value} hónap</span>`;
    rangeV.style.left = `calc(${newValue}% + (${newPosition}px))`;
  };

  range.addEventListener("input", setValue);
  setValue();

  document.getElementById("duration-up").addEventListener(
    "click", function () {
      var ranger = document.getElementById("loan-duration");
      ranger.stepUp(1);
      ranger.dispatchEvent(new Event("input"));
      ranger.dispatchEvent(new Event("change"));
    }
  );
  document.getElementById("duration-down").addEventListener(
    "click", function () {
      var ranger = document.getElementById("loan-duration");
      ranger.stepDown(1);
      ranger.dispatchEvent(new Event("input"));
      ranger.dispatchEvent(new Event("change"));
    }
  );
}

/**
 * Get new calculation.
 */
function calculatorElement(){
  document.getElementById("calculationReq").addEventListener( "click", function(event){

    event.preventDefault();
    var formData = new FormData(document.getElementById("apiCalculator"));

    jQuery.ajax({
      type: "POST",
      url: window.atob(document.getElementById("apiCalculator").getAttribute("action")),
      async: true,
      // beforeSend: this.beforeGetOffers(),
      data: formData,
      processData: false,
      contentType: false,
      dataType: "json",
      crossDomain: true,
      success: function (result) {
        document.getElementById("offerList").innerHTML = "";
        document.getElementById("offerDetailModals").innerHTML = "";
        if(result.offers){
          result.offers.forEach(function(offer){
            document.getElementById("offerList").innerHTML += offer;
          });
          result.modals.forEach(function(modal){
            document.getElementById("offerDetailModals").innerHTML += modal;
          });
        } else {
          document.getElementById("offerList").innerHTML = document.getElementById("no-offer").innerHTML
        }
        // InstaCashOffers.afterGetOffers(result);
        // InstaCashOffers.frontEndCalculation();
      },
      error: function(XMLHttpRequest, textStatus, errorThrown) {
        alert("Status: " + textStatus);
      }
    }).then(function(){
      secondaryPagination(true);
    });
  });
  document.getElementById("amount").addEventListener(
    "keyup",function () {
      this.value = numberFormat(this.value.replace(/[^0-9]/g, "").replace(/\s+/g, ""));
    }
  );
  document.getElementById("salary").addEventListener(
    "keyup",function () {
      this.value = numberFormat(this.value.replace(/[^0-9]/g, "").replace(/\s+/g, ""));
    }
  );
}

/**
 * Terms menu generate.
 */
function termMenuGenerate(){
  let termsContent = document.getElementById("term-single");
  let topicList    = document.getElementById("topic-list");

  if(null !== termsContent){

    let sections = termsContent.querySelectorAll("h6");
    let index    = 1;

    // Add menu elements.
    sections.forEach(function(target){

      target.setAttribute('id', 'section-' + index);
      document.getElementById('topic-list').innerHTML += "<li><a href=#section-"+index+">"+target.innerText+"</a></li>";
      index++;

    });

    // Highlight element on scroll.
    window.onscroll = () => {
      var current = "";

      sections.forEach((section) => {

        const sectionTop = section.offsetTop;
        if (pageYOffset >= sectionTop - 60) {
          current = section.getAttribute("id");
        }

      });

      let active = topicList.querySelector("a.active");
      let target = topicList.querySelector("a[href='#" + current + "']");

      if ( null !== active ) {

        active.classList.remove("active");

      }
      if ( null !== target ) {

        target.classList.add("active");

      }
    };
  }
}

/**
 * Handle page selector.
 */
function selectorHandling(){
  let boxes = document.querySelectorAll(".box-square");
  let nextStep = document.getElementById("nextStep");
  if (null !== boxes) {
    boxes.forEach(function(target){
      target.addEventListener("click", function(){
        boxes.forEach(function(box){
          box.classList.add("bg-gray");
        });
        target.classList.remove("bg-gray");
        nextStep.disabled = false;
        nextStep.classList.remove("disabled");
        nextStep.href = target.dataset.target;
      });
    });
  }
}

/**
 * AJAX post modal form data.
 */
function modalAjaxPost(target, form_data)
{
  return jQuery.ajax({
    url: window.atob(target.getAttribute("action")),
    type: "POST",
    data: form_data,
    dataType: "json",
    crossDomain: true,
    error: function (error) {
      if (error.responseJSON.data.length !== 0) {
        writeErrors(target, error.responseJSON);
      }
    },
    success: function (response) {
      var modal = document.getElementById("CallbackModal");
      modal.querySelector(".modal-side").innerHTML = document.getElementById("callback-side").innerHTML;
      writeResponseMessage(modal, response.data);
    }
  });
}

/**
 * Display form errors.
 */
function writeErrors(target, response)
{
  let errorWrapper = target.parentNode.querySelector(".error");

  if ( response.data.modalTitle ) {
    errorWrapper.innerHTML += "<p>" + response.data.modalTitle + "</p>";
  }

  if ( response.data.modalBody ) {
    errorWrapper.innerHTML += "<p>" + response.data.modalBody + "</p>";
  }

  if (response.data.fields) {
    for (const [field_name, message] of Object.entries(response.data.fields)) {

      let input_field = target.querySelector("input[name='" + field_name + "']");

      if (!input_field) {
        errorWrapper.innerHTML += "<div>" + message + "</div>";
        continue;
      }

      input_field.setCustomValidity(message);
      input_field.classList.add("is-invalid");
      input_field.parentNode.innerHTML = input_field.parentNode.innerHTML + "<span class='text-danger small'>" + message + "</span>";
    }
  }

  if ( target.querySelectorAll(".steps .step").length > 1 ) {
    loopSteps(target.parentNode);
  }

  target.querySelector("input[name='callback_submit']").disabled = false;
}

/**
 * Display responses.
 */
function writeResponseMessage (target, message) {
  target.querySelector(".modal-title").innerText = message.modalTitle;
  target.querySelector(".modal-description").innerHTML = message.modalBody;
  target.querySelector(".modal-body").setAttribute('style','display:none !important');
  if (message.modalUrl && target.querySelector("input[name='offer_id']").dataset.offerUrl){
    target.querySelector("input[name='offer_id']").setAttribute("data-offer-url", message.modalUrl);
  }
  if (!target.querySelector(".text-block").classList.contains("mt-80")){
    target.querySelector(".text-block").setAttribute('style','display:none !important');
  }
  target.querySelector(".callback-form").reset();
}

/**
 * Footer contact form posting.
 */
function footerContact(contactForm){
  contactForm.addEventListener("submit", (event) => {
    event.preventDefault();
    var formData = {
      "action": "callback_form"
    };

    grecaptcha.execute(event.target.dataset.sitekey, {
      action: "validate_captcha"
    }).then(function (token) {
      contactForm.querySelector("input[name='g-recaptcha']").value = token;
      contactForm.querySelector("input[name='callback_submit']").disabled = true;
      contactForm.querySelectorAll("input").forEach(function (input) {
        if (input.getAttribute("type") !== "checkbox" || input.checked) {
          formData[input.getAttribute("name")] = encodeURIComponent(input.value);
        }
      });
      const textarea = contactForm.querySelector("textarea");
      if (textarea.value) {
        formData[textarea.name] = encodeURIComponent(textarea.value);
      }
      modalAjaxPost(contactForm, formData).then(function(){
        if (event.target.dataset.entryHash) {
            window.open(window.atob(event.target.dataset.entryHash));
        } else {
            new bootstrap.Modal(document.getElementById('CallbackModal'), []).show();
        }
        contactForm.reset();
        contactForm.querySelector("input[name='callback_submit']").disabled = false;
      });
    });
  });
}

/**
 * Javascript pagination to loaded content.
 */
function secondaryPagination(rebind, element){
  var paginatedList;
  if (element) {
    paginatedList = element.parentNode.querySelector(".paginated");
  } else {
    paginatedList = document.querySelector(".paginated");
  }
  const listItems = paginatedList.querySelectorAll(".paginable");
  const paginationLimit = paginatedList.dataset.limit;
  const pageCount = Math.ceil(listItems.length / paginationLimit);
  let currentPage = 1;

  let firstButton = paginatedList.parentNode.querySelector(".paginateFirst");
  let prevButton = paginatedList.parentNode.querySelector(".paginatePrev");
  let nextButton = paginatedList.parentNode.querySelector(".paginateNext");
  let lastButton = paginatedList.parentNode.querySelector(".paginateLast");

  if (2 > pageCount) {
    firstButton.classList.add('d-none');
    prevButton.classList.add('d-none');
    nextButton.classList.add('d-none');
    lastButton.classList.add('d-none');
    return;
  } else {
    firstButton.classList.remove('d-none');
    prevButton.classList.remove('d-none');
    nextButton.classList.remove('d-none');
    lastButton.classList.remove('d-none');
  }


  if (rebind) {

    const firstButtonClone = firstButton.cloneNode(true);
    firstButton.parentNode.replaceChild(firstButtonClone, firstButton);
    const prevButtonClone = prevButton.cloneNode(true);
    prevButton.parentNode.replaceChild(prevButtonClone, prevButton);
    const nextButtonClone = nextButton.cloneNode(true);
    nextButton.parentNode.replaceChild(nextButtonClone, nextButton);
    const lastButtonClone = lastButton.cloneNode(true);
    lastButton.parentNode.replaceChild(lastButtonClone, lastButton);

    firstButton = firstButtonClone;
    prevButton = prevButtonClone;
    nextButton = nextButtonClone;
    lastButton = lastButtonClone;

  }

  const disableButton = (button) => {
    button.classList.add("disabled");
    button.setAttribute("disabled", true);
  };

  const enableButton = (button) => {
    button.classList.remove("disabled");
    button.removeAttribute("disabled");
  };

  const handlePageButtonsStatus = () => {
    if (currentPage === 1) {
      disableButton(prevButton);
      disableButton(firstButton);
    } else {
      enableButton(prevButton);
      enableButton(firstButton);
    }

    if (pageCount === currentPage) {
      disableButton(nextButton);
      disableButton(lastButton);
    } else {
      enableButton(nextButton);
      enableButton(lastButton);
    }
  };

  const stayHigh = () => {
    paginatedList.style.height = paginatedList.clientHeight;
    setTimeout(function () {
      paginatedList.style.height = "";
    }, 500);
  }

  const setCurrentPage = (pageNum) => {
    currentPage = pageNum;

    handlePageButtonsStatus();

    const prevRange = (pageNum - 1) * paginationLimit;
    const currRange = pageNum * paginationLimit;

    listItems.forEach((item, index) => {
      if (index >= prevRange && index < currRange) {
        item.classList.remove("d-none");
        setTimeout(function () {
          item.classList.add("show");
        }, 50);
      } else {
        item.classList.add("show");
        setTimeout(function () {
          item.classList.add("d-none");
        }, 500);
      }
    });
  };

  const nextPage = (pageNum) => {
    currentPage = pageNum;

    stayHigh();
    handlePageButtonsStatus();

    const prevRange = (pageNum - 1) * paginationLimit;
    const currRange = pageNum * paginationLimit;

    listItems.forEach((item, index) => {

      if (index >= prevRange && index < currRange){
        setTimeout(function () {
          item.classList.remove("d-none");
          item.classList.add("show");
          item.classList.add("slide-in-left");
          setTimeout(function () {
            item.classList.remove("slide-in-left");
          }, 500);
        }, 500);
      } else {
        item.classList.add("slide-out-right");
        item.classList.remove("show");
        setTimeout(function () {
          item.classList.add("d-none");
          item.classList.remove("slide-out-right");
        }, 500);
      }
    });
  };

  const prevPage = (pageNum) => {
    currentPage = pageNum;

    stayHigh();
    handlePageButtonsStatus();

    const prevRange = (pageNum - 1) * paginationLimit;
    const currRange = pageNum * paginationLimit;

    listItems.forEach((item, index) => {

      if (index >= prevRange && index < currRange){
        setTimeout(function () {
          item.classList.remove("d-none");
          item.classList.add("show");
          item.classList.add("slide-in-right");
          setTimeout(function () {
            item.classList.remove("slide-in-right");
          }, 500);
        }, 500);
      } else {
        item.classList.add("slide-out-left");
        item.classList.remove("show");
        setTimeout(function () {
          item.classList.add("d-none");
          item.classList.remove("slide-out-left");
        }, 500);
      }
    });
  };

  setCurrentPage(1);
  firstButton.addEventListener("click", () => {
    nextPage(1);
    // paginatedList.parentNode.scrollIntoView();
  });
  prevButton.addEventListener("click", () => {
    nextPage(currentPage - 1);
    // paginatedList.parentNode.scrollIntoView();
  });
  nextButton.addEventListener("click", () => {
    prevPage(currentPage + 1);
    // paginatedList.parentNode.scrollIntoView();
  });
  lastButton.addEventListener("click", () => {
    prevPage(pageCount);
    // paginatedList.parentNode.scrollIntoView();
  });
}

/**
 * Add page events.
 */
document.addEventListener("DOMContentLoaded", function(){
  if (document.body.classList.contains('post-type-archive-thesaurus')) {
    glossarySearch();
  }
  if (document.body.classList.contains('page-template-bnpl-home')) {
    merchantListOrder();
  }
  if (document.body.classList.contains('page-template-agent-leads')) {
    getQuestions();
    agentLeadHandle();
  }
  if (document.body.classList.contains('page-template-calculator')) {
    rangeInput();
    calculatorElement();
  }
  // if (document.body.classList.contains('page-template-selector')) {
  //   selectorHandling()
  // }
  // if (document.body.classList.contains('single-terms') || document.body.classList.contains('page-template-dinamyc-page')) {
  //   termMenuGenerate()
  // }
  if (null !== document.querySelector("#term-single")) {
    termMenuGenerate()
  }
  if(null !== document.querySelector(".secondary-pagination")) {
    document.querySelectorAll(".secondary-pagination").forEach(function(element){
        secondaryPagination(false, element);
    });
  }
  if(null !== document.querySelector(".foot.callback-form")) {
    footerContact(document.querySelector(".foot.callback-form"));
  }
  if (document.body.classList.contains('page-template-mgm-page')) {
    document.querySelector("input[name='mgm_phone']").addEventListener("keyup", (event) => {
        document.getElementById("apiUserCreate").parentNode.querySelector(".error").innerHTML = '';
    });
    document.getElementById("apiUserCreate").addEventListener("submit", (event) => {

      event.preventDefault();

      const form = document.getElementById("apiUserCreate");
      var form_data = {
          "action": "mgm_create_user",
          "phone": form.querySelector("input[name='mgm_phone']").value,
          "referral": form.querySelector("input[name='offer_id']").value
      };

      form.parentNode.querySelector(".error").innerHTML = '';
      form.querySelector("input[name='mgm_submit']").disabled = true;

      modalAjaxPost(form, form_data).then(function(response){

        if (!response.success) {
            form.parentNode.querySelector(".error").innerHTML = response.data.message;
            form.querySelector("input[name='mgm_submit']").disabled = false;
        } else {
            if (form.querySelector("input[name='offer_id']").dataset.offerUrl) {
            window.open(form.querySelector("input[name='offer_id']").dataset.offerUrl, "_blank");
            }
        }
      });

    });
  }

  // Check available cookie and load scripts.
  var cookie = instacash.Cookies.get("cookie-notice");
  if (cookie) {
    const consent = JSON.parse(cookie);
    for(const type in consent) {
      if (consent[type]) {
        insertScript(document.querySelector(".cookie-settings input[data-name='" + type + "']").dataset.target);
      }
    };
  }
  instacash.Modal.getOrCreateInstance(document.getElementById("cookieModal"));
  document.querySelector(".cookie-notice").classList.remove("d-none");

  // Set all .nav-cta class modal action.
  document.querySelectorAll(".nav-cta[data-method='modal']").forEach(function(cta){
    cta.addEventListener("click", function(event){
      event.preventDefault();
      if ( "agent" in event.target.dataset ) {
        icashGetFormTemplate(event.target.dataset.agent, true);
      } else {
        icashGetFormTemplate();
      }
    });
  });

  var modal = document.getElementById("callback-modal-content");
  modal.querySelectorAll("form input").forEach(function(input){
    input.addEventListener("blur", () => {
      modal.querySelector(".error").innerText = "";
      input.classList.remove("is-invalid");
      input.setCustomValidity("");
      if (!input.checkValidity()) {
        input.classList.add("is-invalid");
      }
    });
  });

  modal.querySelector(".callback-modal.callback-form").addEventListener("submit", (event) => {

    event.preventDefault();

    // Validate captcha before sending
    var $siteKey = modal.querySelector(".callback-modal.callback-form").dataset.sitekey;
    if ("" !== $siteKey) {
      grecaptcha.execute($siteKey, {action:"validate_captcha"}).then(function(token) {
        document.querySelector(".callback-modal.callback-form input[name='g-recaptcha']").value = token;
        submitForm(modal);
      });
    } else {
        submitForm(modal);
    }

  });
});

/**
 * Modal form submit action.
 */
function submitForm(modal) {
    var form_data = {"action": "callback_form"};

    modal.querySelector("input[name='callback_submit']").disabled = true;
    modal.querySelectorAll(".callback-form input").forEach(function(element){
        if (element.type !== "checkbox" || element.checked) {
            form_data[element.name] = encodeURIComponent(element.value);
        }
    });

    modal.querySelectorAll(".callback-form select").forEach(function(element){
        if (element.dataset.field) {
            form_data[element.dataset.field] = parseInt(element.options[element.selectedIndex].dataset.value.replace(/\D+/g, ""));
        }
        form_data[element.name] = encodeURIComponent(element.value);
    });

    const textarea = modal.querySelector(".callback-form textarea");
    if (textarea.value) {
        form_data[textarea.name] = encodeURIComponent(textarea.value);
    }

    if ("true" === form_data.low_value) {
        form_data.form_type = "Waitlist";
        delete form_data.low_value;
    }

    modalAjaxPost(document.querySelector(".callback-modal.callback-form"), form_data).then(function(){
        if ("Waitlist" === form_data.form_type) {
            window.open(modal.querySelector("input[name='low_value']").dataset.redirect, "_blank");
        } else if (modal.querySelector(".scheduler button")) {
            modal.querySelector(".scheduler button").click();
        } else if (modal.querySelector("input[name='offer_id']").dataset.offerUrl) {
            window.open(modal.querySelector("input[name='offer_id']").dataset.offerUrl, "_blank");
        }
    });
}

/**
 * Modal form submit event diverter.
 */
const average = array => array.reduce((a, b) => parseInt(a) + parseInt(b)) / array.length;
function modalDiverter(event) {
    let modal = document.getElementById("CallbackModal");
    modal.querySelector("input[name='low_value']").value = false;
    modal.querySelector(".redirect").style.display = "none";
    modal.querySelector(".appointment").style.display = "";

    if (parseInt(modal.querySelector("select[name='cart_size']").value) > 0) {

        let amounts = modal.querySelector("select[name='avarage_income']").value.split("_");
        let avg = average(amounts);
        let personal = parseInt(modal.querySelector("input[name='personal_buy']").value);

        if(((avg / 100) * personal) > parseInt(modal.dataset.targetAmount)) {
            return;
        }
    }

    modal.querySelector("input[name='low_value']").value = true;
    modal.querySelector(".appointment").style.display = "none";
    modal.querySelector(".redirect").style.display = "";
}

/**
 * handle FAQ elements.
 */
function getQuestions() {
  document.getElementById("question-wrapper").innerHTML = "";
  prescoreQuestions.forEach(function(row, i){
    var template = document.querySelector("#question-template .question");
    var questionRow = template.cloneNode(true);
    questionRow.setAttribute("data-answer", row.required);
    questionRow.querySelector(".q-title").innerText = row.question;
    questionRow.querySelector(".q-info").innerText = row.information;
    questionRow.querySelectorAll(".btn-decision").forEach(function(button){
      button.addEventListener("click", function(event){
        event.target.parentNode.querySelectorAll(".btn-decision").forEach(function(element){
          element.classList.remove("active");
        });
        event.target.classList.add("active");
      });
    });
    document.getElementById("question-wrapper").appendChild(questionRow);
  });
}

/**
 * Agent lead form handling.
 */
function agentLeadHandle() {
  document.querySelector(".btn-wrapper .reset").addEventListener("click", function(event){
    document.querySelector(".btn-wrapper .evaluation").classList.remove("d-none");
    document.querySelector(".btn-wrapper .nav-cta").classList.add("d-none");
    document.querySelector(".btn-wrapper .reset").classList.add("d-none");
    getQuestions();
  });
  document.querySelector(".btn-wrapper .evaluation").addEventListener("click", function(event){
    var ko = false;
    var timer = 100;
    document.querySelectorAll("#question-wrapper .question").forEach(function(element, index){
      element.querySelectorAll(".btn-decision").forEach(function(button){
        button.classList.add("disabled");
      });
      var answer = element.querySelector(".btn-decision.active");
      if(answer && element.dataset.answer == answer.dataset.answer){
        setTimeout(function(){
          element.classList.remove("bg-gray-100");
          element.classList.remove("bg-danger");
          element.classList.add("bg-success");
        }, 100 * index, element);
      }else{
        setTimeout(function(){
          element.classList.remove("bg-gray-100");
          element.classList.remove("bg-success");
          element.classList.add("bg-danger");
        }, 100 * index, element);
        ko = true;
      }
      timer = 100 * index;
    });
    event.target.classList.add("disabled");
    setTimeout(function(){
      if(!ko){
        document.querySelector(".btn-wrapper .nav-cta").classList.remove("d-none");
      }
      document.querySelector(".btn-wrapper .reset").classList.remove("d-none");
      document.querySelector(".btn-wrapper .evaluation").classList.add("d-none");
    event.target.classList.remove("disabled");
    },timer+100,ko);
  });
  document.querySelector(".agent-tag .tagged").innerHTML = document.getElementById("tagged-agent").innerText;
}

/**
 * Glossary search placer.
 */
function glossarySearch() {

  document.getElementById("gloss").addEventListener("click",function(){setTimeout(searchGlossary, 50);});
  document.getElementById("glossaryShow").addEventListener("click",function(event){
    document.querySelectorAll(".note[style*='display:none']").forEach(function(item){
      item.style.display = "";
    });
    event.target.classList.add("d-none");
    document.getElementById("glossarySearch").dispatchEvent(new Event("keyup"));
  });
}

/**
 * Glossary search method.
 */
function searchGlossary(event) {
  var input, filter, wrapper, element, a, i, limit, showIndex;
  input = event.target;
  filter = input.value.toUpperCase();
  wrapper = document.getElementById("glossary");
  element = wrapper.getElementsByClassName('note');
  limit = document.getElementById("glossaryShow").classList.contains("d-none") ? element.length : 9;
  showIndex = 0;

  for (i = 0; i < element.length; i++) {
    a = element[i].getElementsByTagName("h6")[0];
    if (a.innerHTML.toUpperCase().indexOf(filter) > -1) {
      if (showIndex < limit) {
        element[i].style.display = "";
        showIndex = showIndex+1;
      } else {
        element[i].style.display = "none";
      }
    } else {
      element[i].style.display = "none";
    }
  }
}

/**
 * Add cookies personalized save function.
 */
document.querySelector(".cookie-save").addEventListener("click", function(){
  let values = {}
  document.querySelectorAll(".cookie-settings input[type='checkbox']").forEach(function(check){
    values[check.dataset.name] = check.checked;
    if (check.checked) {
      insertScript(check.dataset.target);
    }
  });
  new instacash.Alert(document.querySelector(".cookie-notice")).close();
  instacash.Cookies.set("cookie-notice", JSON.stringify(values), {expires: 30});
});

/**
 * Add Accept All function to cookie buttons.
 */
document.querySelectorAll(".cookie-acceptall").forEach(function(accept){
  accept.addEventListener("click", function(){
    let values = {}
    document.querySelectorAll(".cookie-settings input[type='checkbox']").forEach(function(check){
      values[check.dataset.name] = true;
      insertScript(check.dataset.target);
    });
    new instacash.Alert(document.querySelector(".cookie-notice")).close();
    instacash.Cookies.set("cookie-notice", JSON.stringify(values), {expires: 30});
  });
});

/**
 * Show selector modal if available.
 */
window.onload = () => {
    if(instacash.Cookies.get("page-selector")){
        return;
    }
    let welcomeModal = document.getElementById("selectorModal");
    if (!welcomeModal) {
        return;
    }

    instacash.Modal.getOrCreateInstance(welcomeModal).show();

    // Add selection effect to page buttons.
    let pages = document.querySelectorAll(".page-select");
    pages.forEach(function(element){
        element.addEventListener("click", function(event){
            event.preventDefault();
            instacash.Modal.getOrCreateInstance(document.getElementById("selectorModal")).hide();
            if("" !== this.dataset.expire) {
                instacash.Cookies.set("page-selector", true);
            }
            if(location.href == this.dataset.url) {
                return;
            }
            location.href = this.dataset.url;

            // pages.forEach(function(page){
            //     page.classList.remove("bg-gray");
            // });
            //
            // this.classList.add("bg-gray");
            // document.getElementById("page-select-btn").href = this.dataset.url;
            // document.getElementById("page-select-btn").classList.remove("disabled");
        });
    });

    // Open selected page.
    // document.getElementById("page-select-btn").addEventListener("click", function(){
    //     instacash.Modal.getOrCreateInstance(document.getElementById("selectorModal")).hide();
    //
    //     if("" !== this.dataset.expire) {
    //         instacash.Cookies.set("page-selector", true);
    //     }
    //     if(location.href == this.href) {
    //         return;
    //     }
    //     location.href = this.href;
    // });
}

/**
 * Set selected package.
 */
function packageSelect(event) {
    document.querySelector("#CallbackModal select[name='package']").value = event.target.dataset.package;
}

/**
 * Modal extend build steps.
 */
function loopSteps(modal) {
    let steps = document.querySelectorAll(".steps .step");

    let bubble = document.createElement("div");
    bubble.classList.add("col");
    bubble.classList.add("p-1");
    bubble.classList.add("mx-1");
    bubble.classList.add("bg-domain-light");
    bubble.classList.add("rounded");

    modal.querySelector(".steps-row").innerHTML = "";

    for(var i=0;i<steps.length;i++){
        var stepBubble = bubble.cloneNode(false);
        stepBubble.classList.add("block-" + i);
        modal.querySelector(".steps-row").appendChild(stepBubble);
    }

    steps.forEach((step, index) => {
        if (step.querySelector(".next-step")) {
            step.querySelector(".next-step").replaceWith(step.querySelector(".next-step").cloneNode(true));
            step.querySelector(".next-step").addEventListener("click", (event) => {
                event.preventDefault();
                let valid = true;
                step.querySelectorAll("input:invalid").forEach((input) => {
                    input.classList.add("is-invalid");
                    valid = false;
                })

                if (!valid) {
                    return;
                }

                steps[index + 1].querySelectorAll("input").forEach((input) => {
                    if (!input.classList.contains("mih-unset")) {
                        input.removeAttribute("disabled");
                    }
                })

                step.classList.add("d-none");
                steps[index + 1].classList.remove("d-none");
                document.querySelector(".steps-row .block-" + (index + 1)).classList.remove("bg-domain-light");
                document.querySelector(".steps-row .block-" + (index + 1)).classList.add("bg-domain-dark");
                document.querySelector("input[name='form_type']").value = "Demo";
            });
        }
        if(index != 0) {
            step.classList.add("d-none");
        } else {
            modal.querySelector(".block-" + index).classList.remove("bg-domain-light");
            modal.querySelector(".block-" + index).classList.add('bg-domain-dark');
            step.classList.remove("d-none");
        }
    });
}

/**
 * Merchants list order handling.
 */
function merchantListOrder() {
    const categories = document.querySelectorAll("ul[aria-labelledby='dropdownSort'] .dropdown-item");
    const merchants = document.getElementById("merchant-list");

    document.getElementById("dropdownSort").addEventListener("click", function(){
        document.querySelector("ul[aria-labelledby='dropdownSort']").style.display = "block";
    });

    categories.forEach(function(item, index){
        item.addEventListener("click", function(){
            categories.forEach(function(listElement){
                listElement.classList.remove("active");
            });
            this.classList.add("active");
            document.querySelector("ul[aria-labelledby='dropdownSort']").style.display = "none";
            var countElements = 0;
            merchants.querySelectorAll(".merchant-card").forEach(function(element, index){
                if ('all' === item.dataset.value || element.dataset.category === item.dataset.value) {
                    countElements++;
                    element.classList.add("paginable");
                    if (countElements <= merchants.dataset.limit) {
                        element.classList.remove("d-none");
                    }
                    setTimeout(function () {
                        element.classList.remove("fade");
                    }, 50);
                } else {
                    element.classList.remove("paginable");
                    element.classList.add("fade");
                    setTimeout(function () {
                        element.classList.add("d-none");
                    }, 500);
                }
            });
            document.getElementById("countCategory").classList.add("fade");
            setTimeout(function () {
                document.getElementById("countCategory").innerText = countElements;
                document.getElementById("countCategory").classList.remove("fade");
            }, 200);
            secondaryPagination(true, merchants.closest('.secondary-pagination'));
        });
    })
}


/**
 * Add async script to load dinamically.
 */
function insertScript(target) {
  if (target) {
    if (!isValidUrl(target)) {
      executeScript(target);
      return;
    }

    let newScript = document.createElement("script");
    newScript.type = "text/javascript";
    newScript.setAttribute("async", "true");
    newScript.setAttribute("src", target);
    document.body.firstChild.appendChild(newScript);
  }
}

/**
 * Check URL validity.
 */
function isValidUrl(string) {
  try {
    new URL(string);

    return true;
  } catch (exception) {
    console.log(exception);

    return false;
  }
}

/**
 * Execute consent script.
 */
function executeScript(scriptString){
  try {
    let execute = new Function(scriptString);
    execute();

    return true;
  } catch (exception) {
    console.log(exception);

    return false;
  }
}

/**
 * Vote to merchant function.
 */
function voteToThis(event) {
    event.preventDefault();

    let card = event.target.closest(".merchant-card");
    let votes = instacash.Cookies.get("merchant-vote");
    if (votes == undefined) {
        votes = [];
    } else {
        votes = JSON.parse(votes);
    }
    if (-1 != votes.indexOf(card.querySelector(".name").innerText)) {
        return;
    }
    xhrRequest(
        {
            "votedMerchant": card.querySelector(".name").innerText,
               "pageNonce":document.getElementById("pageNonce").value,
               "pageId":document.getElementById("pageId").value
        },
        card,
        votes
    );
}
/**
 * Vote function ajax.
 */
function xhrRequest(formData, card, votes)
{
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
        if (this.readyState == xhr.DONE && this.status == 200) {
            votes.push(card.querySelector(".name").innerText);
            instacash.Cookies.set("merchant-vote", JSON.stringify(votes), {expires:1});
            card.querySelector(".vote-number").innerText = parseInt(card.querySelector(".vote-number").innerText) + 1;
            return;
        }
        if (this.readyState == xhr.DONE && (this.status == 503 || this.status == 400)) {
            console.log("Vote validation error!");
        }
    };
    xhr.open("POST", window.atob(document.getElementById("partnerSearch").dataset.action) + "?action=voteToMerchant", true);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.send(serializeObject(formData));
}

/**
 * Serialize data to XHR sending.
 */
function serializeObject(obj)
{
    var serialized = [];
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            serialized.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
        }
    }
    return serialized.join('&');
};

/**
 * Search merchant in list.
 */
function merchantSearch(event) {
    var input, filter, wrapper, element, title, link, i, limit, showIndex;
    input = event.target;
    filter = input.value.toUpperCase();
    wrapper = document.getElementById("future-partner-list");
    element = wrapper.getElementsByClassName('merchant-card');
    limit = 9;
    showIndex = 0;

    for (i = 0; i < element.length; i++) {
        title = element[i].getElementsByClassName("name")[0];
        link = element[i].getElementsByClassName("description")[0];
        if (title.innerHTML.toUpperCase().indexOf(filter) > -1 || link.innerHTML.toUpperCase().indexOf(filter) > -1) {
            if (showIndex < limit) {
                element[i].classList.remove("d-none");
                element[i].classList.add("show");
                showIndex = showIndex+1;
            } else {
                element[i].classList.remove("show");
                element[i].classList.add("d-none");
            }
        } else {
            element[i].classList.remove("show");
            element[i].classList.add("d-none");
        }
    }
}

/**
 * Export callable methods.
 *
 * like HTML elements: onclick="globalThis.instacash.[methodName](event);"
 */
module.exports.voteToThis = (event) => {
    voteToThis(event);
}
module.exports.merchantSearch = (event) => {
    merchantSearch(event);
}
module.exports.packageSelect = (event) => {
    packageSelect(event);
}
module.exports.searchGlossary = (event) => {
  searchGlossary(event);
}
module.exports.modalDiverter = (event) => {
  modalDiverter(event);
}
module.exports.instaForm = (offerId) => {
  icashGetFormTemplate(offerId);
}
module.exports.showDetails = (event, offerId) => {
  showDetails(event, offerId);
}
